import { IconCalendar } from "@tabler/icons-react";
import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateInputWithIcon = () => {
  const [selectedDate, setSelectedDate] = useState(new Date()); // set default date

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  return (
    <div className="input-icon">
      {/* <IconCalendar size={18} /> */}

      {/* Datepicker */}
      <DatePicker
        selected={selectedDate}
        onChange={handleDateChange}
        className="form-control w-100"
        placeholderText="Select a date"
        dateFormat="yyyy-MM-dd"
      />
    </div>
  );
};

export default DateInputWithIcon;
